import { mdClient } from '@LSP/websocket/MdClient/MdWebSocketBase';
import { Callable } from '@prophecy/interfaces/generic';
import { useGlobalVariables } from 'frontend/core/src/context/globalConfig/securedConfigHook';
import { BackEndCodeLanguage } from 'frontend/core/src/graphqlTypes/enums';
import { useState, useRef, useEffect } from 'react';

import { useProjectState } from '../Project/hooks';
import { ProjectCodeGenStatus } from './types';

export function useProjectCodeGenStatus(projectId: string, enabled: boolean) {
  const { language } = useProjectState();
  const isSqlProject = language === BackEndCodeLanguage.sql;
  const isRebuildEnabled = useGlobalVariables().isCodeGenerationEnabled;
  const [isLoading, setLoading] = useState<boolean>(false);
  const [data, setData] = useState<ProjectCodeGenStatus>();
  const cancelCbRef = useRef<Callable>();
  const canSubscribe = !!isRebuildEnabled && enabled && !isSqlProject;
  useEffect(() => {
    if (canSubscribe && !cancelCbRef.current) {
      setLoading(true);
      (async () => {
        /**
         * turning off loader in case of update or error only
         * and not using a finally block as mdClient.subscribeToProjectUpdates would return immediately in case websocket is ready to send message
         * with finally block, it would turn off loader right way which is not expected
         * expected behavior is show loader as subscription starts and turn it off on getting first update or if it throws error
         */
        try {
          cancelCbRef.current = await mdClient.subscribeToProjectUpdates(projectId, (payload) => {
            setLoading(false);
            setData({ Project: payload.project });
          });
        } catch (error) {
          setLoading(false);
        }
      })();
      return () => {
        cancelCbRef.current?.();
        cancelCbRef.current = undefined;
        setLoading(false);
      };
    }
  }, [canSubscribe, projectId]);
  return { data, isInitialLoading: isLoading };
}
